import { render, staticRenderFns } from "./PublicData.vue?vue&type=template&id=64f10b94"
import script from "./PublicData.vue?vue&type=script&lang=js"
export * from "./PublicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports